export const formatAmount = (amount = 0) => {
  const truncated = Math.floor(Number(amount) * 100) / 100

  const formatedAmount = new Intl.NumberFormat(
    'en-US',
    { minimumFractionDigits: 2, maximumFractionDigits: 2 }
  ).format(truncated)

  return formatedAmount
}